import MobileDetect from "mobile-detect";
import { promises, fetch, flexbox } from "modernizr";
// eslint-disable-next-line
import * as libs from "./../common/default_libs";

require("./../common/utilities/polyfills");

// export for others scripts to use

// Allow forEach on the return of querySelectorAll
NodeList.prototype.forEach = Array.prototype.forEach;

function loadePromisesPolyfill(callback) {
  if (!promises) {
    require.ensure(
      [],
      (require) => {
        require("es6-promise").polyfill(); //eslint-disable-line
        callback();
      },
      "promises"
    );
  } else {
    callback();
  }
}

function loadeFetchPolyfill(callback) {
  if (!fetch) {
    require.ensure(
      [],
      (require) => {
        require("whatwg-fetch"); //eslint-disable-line
        callback();
      },
      "fetch"
    );
  } else {
    callback();
  }
}

function goToTouch() {
  require.ensure(
    [],
    (require) => {
      require("./../touch/reader");
    },
    "touch"
  );
}

function goToNotSupported() {
  require.ensure(
    [],
    (require) => {
      require("./../touch/notSupported");
    },
    "touch"
  );
}

function goToMobile() {
  if (flexbox) {
    goToTouch();
  } else {
    goToNotSupported();
  }
}

function goToWeb() {
  require.ensure(
    [],
    (require) => {
      require("./../web/reader");
    },
    "web"
  );
}

loadePromisesPolyfill(() => {
  loadeFetchPolyfill(() => {
    const md = new MobileDetect(navigator.userAgent);
    // mobile or tablet:
    if (md.mobile()) {
      goToMobile();
    } else {
      if (
        navigator.platform.indexOf("Mac") > -1 &&
        navigator.maxTouchPoints > 1 &&
        !window.MSStream
      ) {
        goToMobile();
      } else {
        goToWeb();
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/reader/index.js